import { ICommessa } from './../interfaces/ICommessa';
import { IGestioneAllegato } from './../interfaces/IGestioneAllegato';
import { GestioneAllegatiService } from './../services/gestione-allegati.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as Enum from '../utils/enums'
import { TranslateService } from '@ngx-translate/core';
import { AlertUtil } from '../utils/alert-util';
import * as Constants from '../utils/constants';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { DialogService } from 'primeng/api';
import { GestioneAllegatiModalComponent } from '../gestione-allegati-modal/gestione-allegati-modal.component';
import { IAllegati } from '../interfaces/IAllegati';
import { Util } from '../utils/util';
import { OverlayPanel } from 'primeng/overlaypanel';
import { CommessaService } from '../services/commessa.service';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'app-gestione-allegati',
  templateUrl: './gestione-allegati.component.html',
  styleUrls: ['./gestione-allegati.component.css']
})
export class GestioneAllegatiComponent implements OnInit {
  @ViewChild('op') op: OverlayPanel
  @ViewChild('dialog') dialog: Dialog;

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html
  isAffidatario: boolean
  isAggiudicatario: boolean //CR ALLEGATI 14/12/2020 dare la possibilità all'aggiudicatario di inviare allegati 
  isPrefettura: boolean
  isEsecutore: boolean // Modifica del 07/11/2024 - Aggiunto Esecutore
  isReferente: boolean // Modifica del 11/11/2024 - Aggiunto Referente
  isCSE: boolean //Modifica del 06/10/2025 - Aggiunto CSE
  allegati: IGestioneAllegato[]
  attachmentUrl: string = "" // url dell'allegato
  commesse: ICommessa[]
  displayDialog: boolean = false;

  constructor(private translate: TranslateService,
    private alertUtil: AlertUtil,
    private gestioneAllegatiService: GestioneAllegatiService,
    private dialogService: DialogService,
    private commessaService: CommessaService) {
    this.checkUserRole();

  }


  /**
   * push commessa Tutte in array
   */
  private setCommessaDefault() {
    this.commesse = [];
    let commessaDefault: ICommessa = {
      Id: 0,
      Codice: "Tutte",
      Nome: "",
      Descrizione: "",
      Data_inizio_lavori: "",
      Data_fine_lavori: "",
      Responsabile: "",
      GUID_autore: "",
      CUP: "",
      CIG: "",
      Codice_contratto: "",
      Censita: true,
      Cantieri: null,
      Aggiudicatario: null
    };
    this.commesse.push(commessaDefault);
  }

  ngOnInit() {
    setTimeout(() => {
      this.getAllAllegati()
      this.getAllCommesse()
    }, 0);
  }

  private checkUserRole() {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE);
    if (userRole == Enum.USER_TYPE_ENUM.AFFIDATARIO || userRole == Enum.USER_TYPE_ENUM.GVS) {
      this.isAffidatario = true;
      this.isAggiudicatario = false;
    } else if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO) {
      this.isAggiudicatario = true;
      this.isAffidatario = false;
    } else if (userRole == Enum.USER_TYPE_ENUM.PREFETTURA) {
      this.isAggiudicatario = false;
      this.isAffidatario = false;
      this.isPrefettura = true
      // Modifica del 07/11/2024 - Aggiunta la possibilità di inviare file anche all'esecutore
    } else if (userRole === Enum.USER_TYPE_ENUM.ESECUTORE) {
      this.isEsecutore = true;
      // Modifica del 11/11/2024 - Aggiunta la possibilità di inviare file anche al Referente
    } else if (userRole === Enum.USER_TYPE_ENUM.REFERENTE) {
      this.isReferente = true;
    } else if (userRole === Enum.USER_TYPE_ENUM.CSE) {
      this.isCSE = true
    }
  }

  openAllegatoModal() {
    //get header translation
    this.translate.get(["LBL_INVIA_ALLEGATO"]).subscribe(res => {
      //open gruppo modal
      let gruppoModal = this.dialogService.open(GestioneAllegatiModalComponent, {
        data: {},
        header: res["LBL_INVIA_ALLEGATO"],
        width: '50%'
      })

      // refresh allegati when modal is closed and allegato is sended
      gruppoModal.onClose.subscribe((allegato) => {
        if (allegato) {
          this.getAllAllegati()
        }
      })
    })
  }

  /**
   * fetch all allegati
   */
  getAllAllegati(payload?: any) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(payload != null ? payload : {})
    this.gestioneAllegatiService.getAllAllegati(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.allegati = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }


  /**
   * open allegato in other tab
   */
  openAllegato(event: any) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      Id: event.Id
    })
    this.gestioneAllegatiService.visualizzaAllegato(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) {
          let allegatoType: string
          let allegatoNome = event.Nome
          if (!allegatoType) {
            allegatoType = allegatoNome.substring(allegatoNome.lastIndexOf("."));
          }
          if (allegatoType == Enum.FILE_TYPE_ENUM.PDF) {
            Util.showPdf(response)
          } else if (allegatoType == Enum.FILE_TYPE_ENUM.JPEG || allegatoType == Enum.FILE_TYPE_ENUM.JPG
            || allegatoType == Enum.FILE_TYPE_ENUM.PNG) {
            this.attachmentUrl = "data:image/" + allegatoType.substring(1) + ";base64," + response
            //Apertura dell'overlay panel
            //this.op.toggle(event)
            // Modifica del 07/11/2024 - rivista l'apertura degli allegati ad immagine
            this.displayDialog = true;
            setTimeout(() => {
              if (this.dialog) {
                this.dialog.center();
              }
            }, 0); // Usa setTimeout per garantire che l'immagine sia caricata
          } else {
            Util.downloadFile(response, allegatoType, allegatoNome)
          }
          /**se l'utente è aggiudicatario o esecutore e data lettura non è valorizzata
           * viene chiamata la convalida della lettura
           */
          if (this.isAggiudicatario || this.isEsecutore && !event.DataLettura) {
            this.convalidaLettura(event)
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + JSON.stringify(response.error.Stack))
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * open allegato in other tab
   */
  convalidaLettura(event: any) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      Id: event.Id
    })
    this.gestioneAllegatiService.convalidaLettura(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) {
          //
          this.allegati = []
          this.getAllAllegati()
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + JSON.stringify(response.error.Stack))
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * retrieve all commesse
   */
  getAllCommesse() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.commessaService.getAllCommesseAllegati(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.setCommessaDefault();
          response.data.forEach((commessa: ICommessa) => {
            this.commesse.push(commessa)
          });

        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * commessa filtro
   */
  onCommessaClicked(event: any) {
    if (event && event.value.Id > 0) {
      let payload: any = {
        Id: event.value.Id
      }
      this.getAllAllegati(payload)
    } else {
      this.getAllAllegati()
    }
  }


  /**
   * callback fired when allegato delete button is clicked
   * @param allegato 
   */
  openDeleteDialog(allegato: IGestioneAllegato) {
    this.alertUtil.showConfirmationAlert("LBL_CONFIRM_ALLEGATO_DELETE", null, null, null, null, () => {
      this.deleteAllegato(allegato)
    });
  }

  /**
   * call delete allegato service
   * @param allegato 
   */
  deleteAllegato(allegato: IGestioneAllegato) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({ Id: allegato.Id })
    this.gestioneAllegatiService.deleteAllegato(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          //MESSAGGIO OK 
          this.alertUtil.showAlert("LBL_DELETE_ALLEGATO_SUCCESS", null, null, null, () => {
            this.getAllAllegati()
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }
}
